import { render } from "./App.vue?vue&type=template&id=5add7316&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5add7316&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5add7316"

export default script